import React, { useState } from 'react'
import { FundTeamItem } from '../../../../models/Fund';
import { Avatar, Box, ITheme, IconButton, Link, Typography, useTheme } from '@mui/material';
import { LeoImagesFundTeamsPath } from '../../../../resources/api-constants';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

interface IFundTeamItemCardProps {
    member: FundTeamItem;
}

const FundTeamItemCard: React.FC<IFundTeamItemCardProps> = ({ member }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const theme = useTheme() as ITheme;

    const onMailClick = () => {
        window.open("mailto:info@leofinance.co");
    }

    const getShortenText = (text: string): React.ReactNode => {
        if (text.length <= 200){
            return text;
        }
        return <>{text.substring(0, 200)} <Link onClick={() => setIsCollapsed(false)} sx={{ cursor: "pointer", color: theme.palette.primary.dark}}>...</Link></>;
    }
    return <Box display={"flex"} flexDirection={"column"} gap={"26px"} maxWidth={"22%"} flexGrow={1}>
        <Box display={"flex"} gap={"15px"}>
            <Avatar src={`${LeoImagesFundTeamsPath}/${member.photo}`} sx={{ width: "85px", height: "85px" }} />
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"500"}>{member.firstName} {member.lastName}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{member.title}</Typography>
                <Box display={"flex"}>
                    {member.linkedIn && <IconButton size='small'>
                        <LinkedInIcon fontSize='small' />
                    </IconButton>}
                    {member.email && <IconButton size='small' onClick={onMailClick}>
                        <MailOutlineIcon fontSize='small' />
                    </IconButton>}
                </Box>
            </Box>
        </Box>
        <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"400"}>{isCollapsed ? getShortenText(member.description) : member.description}</Typography>
    </Box>
}

export default FundTeamItemCard